<style>
  .v-select .dropdown-menu li a {
    text-align: left !important;
  }
</style>
<style lang="scss">
  @import "../../../../sass/fct/variables";
  @import "~bulma/sass/utilities/mixins";

  @include mobile() {
    .dropdown-menu {
      width: 100%;
      /*transform: translateX(50%);*/
    }
  }

  .dropdown-menu {
    z-index: 10000;
    .option-label {
      text-overflow: ellipsis;
      display: inline-block;
      width: 100%;
      overflow: hidden;
    }
  }

  .v-select {
    display: inline-block;
    width: 160px;
    position: relative;
    /*top: 2px;*/
    font-family: inherit;
    font-weight: 700;

    @include mobile() {
      width: 100% !important;
    }
  }

  .v-select,
  .v-select * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  /* Open Indicator */
  .v-select .open-indicator {

    position: absolute;
    bottom: 16px;
    right: 24px;
    display: inline-block;
    cursor: pointer;
    pointer-events: all;
    transition: all 150ms cubic-bezier(1.000, -0.115, 0.975, 0.855);
    transition-timing-function: cubic-bezier(1.000, -0.115, 0.975, 0.855);
    opacity: 1;
    height: 20px;
    width: 10px;
  }

  .v-select .open-indicator:before {
    border-color: $active-color;
    border-style: solid;
    border-width: 1px 1px 0 0;
    content: '';
    display: inline-block;
    height: 7px;
    width: 7px;
    vertical-align: top;
    transform: translateY(2px) rotate(133deg);
    transition: all 150ms cubic-bezier(1.000, -0.115, 0.975, 0.855);
    transition-timing-function: cubic-bezier(1.000, -0.115, 0.975, 0.855);
    box-sizing: inherit;
  }

  /* Open Indicator States */
  .v-select.open .open-indicator:before {
    transform: rotate(315deg);
  }

  /*.v-select.open > .dropdown-toggle{*/
  /*background-color: #1E2730;*/
  /*}*/

  .v-select.loading .open-indicator {
    opacity: 0;
  }

  .v-select.open .open-indicator {
    bottom: 19px;
  }

  /* Dropdown Toggle */
  .v-select .dropdown-toggle {
    * {
      pointer-events: none;
    }

    overflow: hidden;
    /*border-right: solid 40px rgba(0, 0, 0, 0) !important;*/
    color: #757575;
    filter: drop-shadow(0 0 15px rgba(1,1,1,0.05));
    /*background: url('../assets/select-arr.') no-repeat, #fff;*/
    /*background-position: 119px;*/
    border: none;
    border-radius: 25px;
    padding: 10px 50px 10px 15px;
    font-size: 1rem;
    font-weight: 700;
    appearance: none;
    margin-right: 8px;
    background-color: #fff;

    > .fct-input {
      word-break: keep-all;
      text-overflow: ellipsis;
    }

    &:focus {
      outline: none;
    }

    &:hover {
      box-shadow: 0px 0px 40px -8px #787878;
      cursor: pointer;
    }
  }

  .v-select .dropdown-toggle:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: " ";
    clear: both;
    height: 0;
  }

  /* Clear Button */
  .v-select .dropdown-toggle .clear {
    position: absolute;
    bottom: 4px;
    right: 30px;
    font-size: 23px;
    font-weight: 700;
    // line-height: 1;
    top: 1px;
    color: rgba(60, 60, 60, .5);
    padding: 0;
    border: 0;
    background-color: transparent;
    cursor: pointer;
  }

  /* Dropdown Toggle States */
  .v-select.searchable .dropdown-toggle {
    cursor: pointer;
  }

  .v-select.unsearchable .dropdown-toggle {
    cursor: pointer;
  }

  .v-select.open .dropdown-toggle {
    // border-bottom-color: transparent;
    /*border-bottom-left-radius: 10px;*/
    /*border-bottom-right-radius: 10px;*/
  }


  /* Selected Tags */
  .v-select .selected-tag {
    color: #333;
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 4px;
    height: 23px;
    margin-top: 0;
    // margin: 4px 1px 0px 3px;
    padding: 0 0.25em;
    float: left;
    line-height: 24px;
    overflow: hidden;
  }

  .v-select.single .selected-tag {
    background-color: transparent;
    border-color: transparent;
  }

  .v-select.single.open .selected-tag {
    /*position: absolute;*/
    opacity: .5;
  }

  .v-select.single.open.searching .selected-tag,
  .v-select.single.loading .selected-tag {
    display: none;
  }

  .v-select .selected-tag .close {
    float: none;
    margin-right: 0;
    font-size: 20px;
    appearance: none;
    padding: 0;
    cursor: pointer;
    background: 0 0;
    border: 0;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    filter: alpha(opacity=20);
    opacity: .2;
  }

  .v-select.single.searching:not(.open):not(.loading) input[type="search"] {
    opacity: .2;
  }

  /* Search Input */
  .v-select input[type="search"]::-webkit-search-decoration,
  .v-select input[type="search"]::-webkit-search-cancel-button,
  .v-select input[type="search"]::-webkit-search-results-button,
  .v-select input[type="search"]::-webkit-search-results-decoration {
    display: none;
  }

  .v-select input[type="search"]::-ms-clear {
    display: none;
  }

  .v-select input[type="search"],
  .v-select input[type="search"]:focus {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    font-size: 1em;
    height: 23px;
    display: inline-block;
    border: none;
    outline: none;
    margin: 0;
    padding: 0 0.25em;
    width: 10em;
    max-width: 100%;
    background: none;
    position: relative;
    box-shadow: none;
    color: #fff;
  }

  .v-select.unsearchable input[type="search"] {
    opacity: 0;
    position: absolute;
  }

  .v-select.unsearchable input[type="search"]:hover {
    cursor: pointer;
  }

  .v-select input[type="search"].hidden {
    width: 0px;
    padding: 0;
  }

  .v-select input[type="search"].shrunk {
    width: auto;
  }

  .v-select input[type="search"].empty {
    width: 100%;
  }



  /* Loading Spinner */
  .v-select .spinner {
    opacity: 0;
    position: absolute;
    top: 5px;
    right: 10px;
    font-size: 5px;
    text-indent: -9999em;
    overflow: hidden;
    border-top: .9em solid rgba(100, 100, 100, .1);
    border-right: .9em solid rgba(100, 100, 100, .1);
    border-bottom: .9em solid rgba(100, 100, 100, .1);
    border-left: .9em solid rgba(60, 60, 60, .45);
    transform: translateZ(0);
    animation: vSelectSpinner 1.1s infinite linear;
    transition: opacity .1s;
  }

  .v-select .spinner,
  .v-select .spinner:after {
    border-radius: 50%;
    width: 5em;
    height: 5em;
  }

  /* Disabled state */
  .v-select.disabled .dropdown-toggle,
  .v-select.disabled .dropdown-toggle .clear,
  .v-select.disabled .dropdown-toggle input,
  .v-select.disabled .selected-tag .close,
  .v-select.disabled .open-indicator {
    cursor: not-allowed;
    background-color: #f1f2f2;
    border-color: #f1f2f2;
    box-shadow: none;
    color: #7a7a7a;
  }

  /* Loading Spinner States */
  .v-select.loading .spinner {
    opacity: 1;
  }

  /* KeyFrames */
  @-webkit-keyframes vSelectSpinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes vSelectSpinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  /* Dropdown Default Transition */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .15s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>

<template>
  <div class="dropdown v-select" :class="dropdownClasses">
    <div ref="toggle" @mousedown.prevent="toggleDropdown" :class="['dropdown-toggle', 'clearfix']">
      <input
        ref="search"
        @focus="onSearchFocus"
        @blur="onSearchBlur"
        :id="inputId"
        v-model="search"
        type="text"
        class="form-control fct-input"
        :class="inputClasses"
        autocomplete="off"
        :placeholder="searchPlaceholder"
        :readonly="!searchable"
        :required="true"
        aria-label="Search for option">
      <i ref="openIndicator" role="presentation" class="open-indicator"></i>
    </div>
    <select-options v-show="open"
                    :excluded="excluded"
                    @close="closeDropdown"
                    @input="onSelect"
                    :value="value"
                    :label="label"
                    :options="filteredOptions"
                    :multiple="multiple"
                    :get-option-label="getOptionLabel">
    </select-options>
<!--    <transition :name="transition">-->
<!--      <ul ref="dropdownMenu" class="dropdown-menu" :style="{ 'max-height': maxHeight }">-->
<!--        <li v-for="(option, index) in filteredOptions" v-bind:key="index"-->
<!--            :class="{ active: isOptionSelected(option), highlight: index === typeAheadPointer }"-->
<!--            @mouseover="typeAheadPointer = index">-->
<!--          <a @mousedown.prevent="select(option)">-->
<!--            <slot name="option" v-bind="(typeof option === 'object')?option:{[label]: option}">-->
<!--              {{ getOptionLabel(option) }}-->
<!--            </slot>-->
<!--          </a>-->
<!--        </li>-->
<!--        <li v-if="!filteredOptions.length" class="no-options">-->
<!--          <slot name="no-options">Sorry, no matching options.</slot>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </transition>-->
  </div>
</template>

<script type="text/babel">
  import SelectOptions from "./SelectOptions";

  export default {
    components: { SelectOptions },
    props: {
      inputId: {
        type: String,
        default: ''
      },
      required: {
        type: Boolean,
        default: false
      },
      value: {
        default: null
      },
      excluded: {
        type: Array,
        default: () => []
      },
      disabled: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: false
      },
      maxHeight: {
        type: String,
        default: '400px'
      },
      searchable: {
        type: Boolean,
        default: true
      },
      multiple: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: ''
      },
      options: {
        type: Array,
        default() {
          return []
        },
      },
      clearSearchOnSelect: {
        type: Boolean,
        default: true
      },
      closeOnSelect: {
        type: Boolean,
        default: true
      },
      label: {
        type: String,
        default: ''
      },
      getOptionLabel: {
        type: Function,
        default(option) {
          let {label} = this
          return label ? (option || {})[label] : option;
        }
      },
      onChange: {
        type: Function,
        default: function (val) {
          this.$emit('input', val)
        }
      },
      /**
       * When true, existing options will be filtered
       * by the search text. Should not be used in conjunction
       * with taggable.
       * @type {Boolean}
       */
      filterable: {
        type: Boolean,
        default: true
      },

      /**
       * Callback to determine if the provided option should
       * match the current search text. Used to determine
       * if the option should be displayed.
       * @type   {Function}
       * @param  {Object || String} option
       * @param  {String} label
       * @param  {String} search
       * @return {Boolean}
       */
      filterBy: {
        type: Function,
        default(option, label, search) {
          return (label || '').toLowerCase().indexOf(search.toLowerCase()) > -1
        }
      },

      /**
       * Callback to filter results when search text
       * is provided. Default implementation loops
       * each option, and returns the result of
       * this.filterBy.
       * @type   {Function}
       * @param  {Array} list of options
       * @param  {String} search text
       * @param  {Object} vSelect instance
       * @return {Boolean}
       */
      filter: {
        "type": Function,
        default(options, search) {
          return options.filter((option) => {
            let label = this.getOptionLabel(option)
            if (typeof label === 'number') {
              label = label.toString()
            }
            return this.filterBy(option, label, search)
          });
        }
      }
    },

    data() {
      return {
        search: '',
        open: false,
        mutableValue: null,
        mutableOptions: []
      }
    },

    watch: {
      /**
       * When the value prop changes, update
       * the internal mutableValue.
       * @param  {mixed} val
       * @return {void}
       */
      // search(val) {
      //   this.open = true
      // },
      value(val) {
        this.mutableValue = val
        this.setSearchValue()
      },
      /**
       * When options change, update
       * the internal mutableOptions.
       * @param  {array} val
       * @return {void}
       */
      options(val) {
        this.mutableOptions = val
      },

      /**
       * Always reset the mutableValue when
       * the multiple prop changes.
       * @param  {Boolean} val
       * @return {void}
       */
      multiple(val) {
        this.mutableValue = val ? [] : null
      }
    },

    methods: {
      onSelect(val) {
        this.$emit('input', val)
        this.$nextTick(() => {
          if(this.$refs.search) {
            this.$refs.search.blur()
          }

          this.onSearchBlur()
        })

      },
      closeDropdown() {
        this.open = false
      },
      onInput (val) {
      },
      toggleDropdown(e) {
        if (e.target === this.$refs.openIndicator || e.target === this.$refs.search || e.target === this.$refs.toggle || e.target === this.$el) {
          if (this.open) {
            this.$refs.search.blur() // dropdown will close on blur
          } else {
            if (!this.disabled) {
              this.open = true
              this.$refs.search.focus()
            }
          }
        }
      },

      /**
       * Close the dropdown on blur.
       * @emits  {search:blur}
       * @return {void}
       */
      onSearchBlur() {
        this.closeDropdown()
        this.setSearchValue()
      },
      setSearchValue() {
        this.search = this.getOptionLabel(this.value) || ''
      },

      /**
       * Open the dropdown on focus.
       * @emits  {search:focus}
       * @return {void}
       */
      onSearchFocus() {
        this.open = true
        this.search = ''
        this.$emit('search:focus')
      },
    },

    computed: {
      filteredOptions() {
        if (!this.filterable && !this.taggable) {
          return this.mutableOptions.slice()
        }

        let options = this.search.length ? this.filter(this.mutableOptions, this.search, this) : this.mutableOptions;
        if (this.taggable && this.search.length && !this.optionExists(this.search)) {
          options.unshift(this.search)
        }
        return options
      },

      /**
       * Classes to be output on .dropdown
       * @return {Object}
       */
      dropdownClasses() {
        return {
          open: this.open,
          single: !this.multiple,
          searching: this.searching,
          searchable: this.searchable,
          unsearchable: !this.searchable,
          disabled: this.disabled
        }
      },

      /**
       * Classes to be output on input.form-control
       * @return {Object}
       */
      inputClasses() {
        return {
          hidden: !this.multiple && !this.isValueEmpty && !this.open,
          shrunk: this.multiple && !this.isValueEmpty,
          empty: this.isValueEmpty,
        }
      },

      /**
       * If search text should clear on blur
       * @return {Boolean} True when single and clearSearchOnSelect
       */
      clearSearchOnBlur() {
        return this.clearSearchOnSelect && !this.multiple
      },

      /**
       * Return the current state of the
       * search input
       * @return {Boolean} True if non empty value
       */
      searching() {
        return !!this.search
      },

      /**
       * Return the placeholder string if it's set
       * & there is no value selected.
       * @return {String} Placeholder text
       */
      searchPlaceholder() {
        if (this.isValueEmpty && this.placeholder) {
          return this.placeholder;
        }
      },

      /**
       * Check if there aren't any options selected.
       * @return {Boolean}
       */
      isValueEmpty() {
        if (this.mutableValue) {
          if (typeof this.mutableValue === 'object') {
            return !Object.keys(this.mutableValue).length
          }
          return !this.mutableValue.length
        }

        return true;
      },
    },
    mounted () {
      this.mutableOptions = this.options
      this.setSearchValue()
    }
  }
</script>

<style scoped lang="scss">
  input.fct-input {
    background: none !important;
    color: inherit;
    height: 20px;
    padding: 0;
  }
</style>
